<template>
    <div class="panel panel-default form-horizontal">
        <div class="panel-heading">
            <h5>
                Basic Information

                <i class="fa fa-question-circle" v-tooltip.bottom="tooltip"></i>
            </h5>
        </div>

        <div class="panel-body">
            <text-form-group
                    :value="subscription.purchase_order"
                    name="purchase_order"
                    label="Purchase Order (PO number)"
                    help-text="The subscriber's purchase order (not required)."
                    :error="getError('purchase_order')"
                    @input="update('purchase_order', $event)"
            ></text-form-group>

            <select-form-group
                    :value="subscription.portal_id"
                    name="portal_id"
                    label="Portal"
                    help-text="The portal that the subscription belongs to."
                    :error="getError('portal_id')"
                    @input="update('portal_id', $event)"
                    :options="portalOptions"
            ></select-form-group>

            <select-form-group
                    :value="subscription.subscription_type_id"
                    name="subscription_type_id"
                    label="Subscription Type"
                    help-text="Any subscription type to use for the subscription."
                    :error="getError('subscription_type_id')"
                    @input="update('subscription_type_id', $event)"
                    :options="subscriptionTypeOptions"
                    :nullable="true"
                    placeholder="(none)"
            ></select-form-group>
        </div>
    </div>
</template>

<script>
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {SelectFormGroup, TextFormGroup},

        props: ['subscription', 'portals', 'subscriptionTypes', 'errors'],

        model: {
            prop: 'subscription'
        },

        computed: {
            portalOptions() {
                return this.portals.data.map(portal => {
                    return {
                        value: portal.id,
                        label: portal.attributes.name
                    }
                })
            },

            subscriptionTypeOptions() {
                return this.subscriptionTypes.data
                    .filter(subscriptionType => subscriptionType.attributes.portal_id === parseInt(this.subscription.portal_id))
                    .map(subscriptionType => {
                        return {
                            value: subscriptionType.id,
                            label: subscriptionType.attributes.name
                        }
                    })
            },

            tooltip() {
                return {
                    content: '<p>' +
                    'Enter the portal that the subscription subscribes to, and select a subscription type.' +
                    '</p>',
                    classes: 'help'
                }
            }
        },

        methods: {
            update(key, value) {
                this.$emit('input', {...this.subscription, [key]: value})
            },

            getError(name) {
                return typeof this.errors[name] !== 'undefined' ? this.errors[name][0] : null
            }
        }
    }
</script>
